import { useEffect, useRef, useState } from "react";
import styles from "../components/ImagePreview.module.css";

export const ImagePreview = ({fullScreen, onClose})=> {
    const [FullSize, setFullSize] = useState(false);
    const [PreviewLoaded, setPreviewLoaded] = useState(false);
    const containerRef = useRef(null);
    const imgRef = useRef(null);
    const zoomPointRef = useRef({x:0.5, y:0.5});

    useEffect(()=>{
        setFullSize(false);
        setPreviewLoaded(false);
        
        if(fullScreen) {
        document.body.style.overflow = "hidden";
        }
        else {
        document.body.style.overflow = "";
        }
        return ()=> {
        document.body.style.overflow = "";
        }
    }, [fullScreen]);

    useEffect(() => {
        const el = containerRef.current;
        const img = imgRef.current;
        if(!img && !el) return;
        const cw = el.clientWidth;
        const ch = el.clientHeight;
        if(FullSize) {
            if(img && el) {
                
                if(cw<ch) {
                    img.style.width = cw*2<1000?cw*2+"px": "1000px";
                    img.style.height = "auto";
                }
                else{
                    img.style.height = ch*2<1000?ch*2+"px": "1000px";
                    img.style.width = "auto";
                }
                requestAnimationFrame(()=>{
                    const {x, y} = zoomPointRef.current;
                    el.scrollLeft = (el.scrollWidth - el.clientWidth) * x;
                    el.scrollTop = (el.scrollHeight - el.clientHeight) * y;
                });
                
            }
        }
        else{
            if(cw<ch) {
                img.style.width = cw+"px";
                img.style.height = "auto";
            }
            else{
                img.style.height = ch+"px";
                img.style.width = "auto";
            }
        }
        
    }, [FullSize]);

    useEffect(()=>{
        if(fullScreen && PreviewLoaded) {
            const el = containerRef.current;
            const img = imgRef.current;
            if(img && el) {
                const cw = el.clientWidth;
                const ch = el.clientHeight;
                if(cw<ch) {
                    img.style.width = cw+"px";
                    img.style.height = "auto";
                }
                else{
                    img.style.height = ch+"px";
                    img.style.width = "auto";
                }
                
            }
        }
    }, [fullScreen, PreviewLoaded]);

    useEffect(()=>{
        if(!fullScreen) return;

        const handleKeyDown = (e)=>{
            if(e.key === "Escape") {
                onClose();
            }
        }
        window.addEventListener("keydown", handleKeyDown);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
        }
    }, [fullScreen, onClose]);

    const handleZoom = (e) => {
        const el = containerRef.current;
        if(!el) return;

        const rect = el.getBoundingClientRect();

        const x = (e.clientX - rect.left) / rect.width;
        const y = (e.clientY - rect.top) / rect.height;

        const clamp = (val) => Math.max(0, Math.min(1, val));
        zoomPointRef.current = {
            x: clamp(x),
            y: clamp(y)
            };
        setFullSize(prev => !prev);
        };

    if(!fullScreen) return null;

    const PreviewComponent = (
        <>
        <div className={`${styles.fullScreen} ${fullScreen?styles.open:""}`} onClick={onClose}>
        <div ref={containerRef} className={`${styles.img} ${FullSize?styles.img_fix:""}`} onClick={(e)=>{e.stopPropagation()}}>
            {!PreviewLoaded?<div className={styles.loadingFullScreen}><div className={styles.loader}></div></div>:""}
            {fullScreen?(<img ref={imgRef} src={fullScreen} className={`${FullSize?styles.fullSize:""} ${PreviewLoaded?styles.showImage:""}`} alt="preview" onLoad={()=>{setPreviewLoaded(true)}} onClick={handleZoom} />):""}
        </div>
        <button className={styles.closeButton} onClick={onClose}>X</button>
        </div>
        </>
    );
    return PreviewComponent;
}